import { User } from '@/domain/protocols/User'

/** `user` de `GET /v2/users/me` (API do Account). */
export interface AccountUserRemote {
  id: number
  email: string
  account_type: string
  name: string
  surname: string
  nickname?: string
  phone?: string
  born_at?: string
  pilot?: boolean
  pilot_professional?: boolean
  aircraft_type?: string
  segment?: string
  profile_image_url?: string
  is_email_verified?: boolean
  is_phone_verified?: boolean
  has_password?: boolean
  is_auth_completed?: boolean
  phone_verification_deadline?: string
  trial_to?: string
  trial_reason?: string
}

export const DateResponseMapper = (date: string): Date => {
  if (!date) return null
  const parsed = new Date(date)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}

/** Texto vazio vira `null`, para os consumidores tratarem "sem valor" de um jeito só. */
const OptionalTextMapper = (text: string): string => {
  if (text === undefined || text === null || text === '') return null
  return text
}

export const AccountUserResponseMapper = (user: AccountUserRemote): User => {
  if (!user) return null
  return {
    id: user.id,
    email: user.email,
    accountType: OptionalTextMapper(user.account_type),
    name: OptionalTextMapper(user.name),
    surname: OptionalTextMapper(user.surname),
    nickname: OptionalTextMapper(user.nickname),
    phone: OptionalTextMapper(user.phone),
    bornAt: DateResponseMapper(user.born_at),
    pilot: user.pilot === true,
    pilotProfessional: user.pilot_professional === true,
    aircraftType: OptionalTextMapper(user.aircraft_type),
    segment: OptionalTextMapper(user.segment),
    profileImageUrl: OptionalTextMapper(user.profile_image_url),
    isEmailVerified: user.is_email_verified === true,
    isPhoneVerified: user.is_phone_verified === true,
    hasPassword: user.has_password === true,
    isAuthCompleted: user.is_auth_completed === true,
    phoneVerificationDeadline: DateResponseMapper(user.phone_verification_deadline),
    trialTo: DateResponseMapper(user.trial_to),
    trialReason: OptionalTextMapper(user.trial_reason)
  }
}
